import { regex } from 'react-admin';

// Mirrors the format rule enforced by the backend (anna-common):
// DigitalTokenIdentifiersValidator / EquivalentDigitalTokenGroupValidator both require exactly
// 9 alphanumeric characters. GUI-only convenience check, same pattern as validateLei - the backend
// validators remain the binding, authoritative rule.
const validateDigitalTokenFormat = regex(/^[A-Za-z0-9]{9}$/, 'resources.isin.digitalTokenFormatInvalid');

export default validateDigitalTokenFormat;
